import { PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import { getPlayerUrl } from '@services/LinkRuleService';
import PlayerIdentifier from '@shared/Identifier/PlayerIdentifier';
import type { Player, RoundPhase, SubstitutionStatus } from '@shared-types/match.types';

import * as classes from './styles.module.scss';

export const EventPlayer = ({
  className,
  id,
  name,
  fieldPosition,
  imageUrl,
  enableLink,
  isGoalEvent,
  substitutionStatus,
  phase,
}: {
  className?: string;
  id: string;
  name: string;
  fieldPosition: string;
  imageUrl: string;
  enableLink: boolean;
  isGoalEvent?: boolean;
  substitutionStatus?: SubstitutionStatus;
  phase?: RoundPhase;
}) => {
  const content = useMemo(() => {
    const player = { id, name, fieldPosition, imageUrl } as Player;
    return (
      <PlayerIdentifier
        className={clsx(classes.identifier, 'pk-py--0')}
        player={player}
        useFullName
        borderRadius='spacing-xl3'
        rounded
        phase={phase}
      >
        {substitutionStatus && (
          <PkIcon
            slot='suffix'
            className='pk-mr--s'
            size={25}
            name={`football-substitution-${substitutionStatus}`}
            color={`support-${substitutionStatus === 'in' ? '01' : '04'}`}
          />
        )}
      </PlayerIdentifier>
    );
  }, [fieldPosition, id, imageUrl, name, substitutionStatus, phase]);

  const cssClassName = clsx({
    [className]: className,
    [classes.matchevent]: true,
    [classes[`matchevent--${substitutionStatus}`]]: substitutionStatus,
    [classes.matcheventGoal]: isGoalEvent,
  });

  return enableLink && fieldPosition ? (
    <a className={cssClassName} href={getPlayerUrl(id, undefined, phase)}>
      {content}
    </a>
  ) : (
    <div className={cssClassName}>{content}</div>
  );
};

export default memo(EventPlayer);
